import React from 'react';
import PropTypes from 'prop-types';

import styles from './Loading.scss';
import LoadingAnimation from 'Components/LoadingAnimation';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

const Loading = (props) => {
  const { type, header, description, style } = props;
  const size = type === 'component' ? 'small' : 'medium';
  const loadingContainer = (
    <div className="Loading__container" style={style}>
      <LoadingAnimation size={size} />
      <div className="Loading__text">
        <h2 className="Loading__header">{header}</h2>
        {description ? (
          <p className="Loading__description">{description}</p>
        ) : null}
      </div>
    </div>
  );
  if (type === 'page') {
    return (
      <main className={`Loading Loading--${type}`}>{loadingContainer}</main>
    );
  }
  return <div className={`Loading Loading--${type}`}>{loadingContainer}</div>;
};

Loading.propTypes = {
  type: PropTypes.oneOf(['page', 'component', 'payment']),
  header: PropTypes.node,
};

Loading.defaultProps = {
  type: 'page',
  header: <ConnectedFormattedMessage id="loading.label" />,
};

export default Loading;
